import { createContext } from "react";

const GovernmentShipScreen = createContext<any>(null);

export default GovernmentShipScreen;
